<template>
    <BaseDialog
        v-model:visible="visible"
        modal
        :closable="true"
        dismissable-mask
        class="modal-meter-revoke-consentw-3/4 md:w-1/2"
        :style="{
            '--p-dialog-header-padding': '0rem',
        }"
        :pt="{
            header: 'flex-col-reverse p-0!',
            headeractions: 'ml-auto',
            title: 'text-primary mb-4',
        }"
        :header="t('title')"
    >
        <div class="w-full h-full">
            <!-- texte de warning avant de révoquer le consentement -->
            <p class="text-center pt-6">
                {{ t("warning", { idsource: idsource }) }}
            </p>
        </div>
        <template #footer>
            <div class="flex gap-2 w-full justify-between">
                <BaseButton
                    @click="visible = false"
                    :label="t('button_quit')"
                    severity="secondary"
                    text
                />
                <BaseButton
                    @click="onConfirmDelete"
                    :label="t('button_delete')"
                    severity="danger"
                    icon="pi pi-trash"
                    autofocus
                    :loading="loading"
                />
            </div>
        </template>
    </BaseDialog>
</template>

<script setup lang="ts">
// ================================
// IMPORTS
// ================================
// Vue
import { useI18n } from "vue-i18n"
import { ref } from "vue"

// Service
import { ConsentService } from "@core/services"
const consentService = new ConsentService()

// ================================
// INTERNATIONALIZATION
// ================================
const { t } = useI18n({
    messages: {
        fr: {
            title: "Êtes-vous sûr de vouloir révoquer ce consentement ?",
            button_delete: "Oui, révoquer",
            button_quit: "Non, annuler",
            warning: ({ named }: { named: (key: string) => string }) =>
                `Une fois le consentement révoqué, les données de la source ${named("idsource") ? `"${named("idsource")}"` : ""} ne seront plus mises à jour. Si vous souhaitez exercer votre droit a l’oubli (RGPD), veuillez nous écrire à rgpd@homeys.io`,
        },
    },
})

// ================================
// TYPES & INTERFACES
// ================================

const emit = defineEmits(["update"])
const loading = ref(false)

// ================================
// PROPS & EMITS
// ================================
type Props = {
    idsource?: string
    consentId: string
}
const props = defineProps<Props>()

const [visible] = defineModel<boolean>("visible", {
    required: true,
    default: false,
})

/**
 * à la confirmation du révoquement on appelle la route pour révoquer le consentement
 * et on emet un evenement pour update les sources
 */
const onConfirmDelete = async () => {
    loading.value = true
    await consentService.revokeConsent(props.consentId)
    emit("update")
    loading.value = false
    visible.value = false
}
</script>

<style scoped></style>
